import { Link } from "react-router-dom";
import { navLinks } from "@/mocks/homeData";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  const footerNavLabels: Record<string, string> = {
    "/": "nav.home",
    "/blog": "nav.blog",
    "/partners": "nav.partners",
    "/contact": "nav.contact",
  };

  return (
    <footer className="bg-background-950 mb-3 md:mb-4 overflow-hidden">
      <div className="px-6 md:px-10 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr_1.5fr] gap-10 md:gap-8">
          <div>
            <h3 className="font-heading text-2xl md:text-3xl font-light text-background-50">
              {t("footer.heading")}
            </h3>
            <p className="text-sm text-background-50/50 mt-2 leading-relaxed">
              {t("footer.description")}
            </p>


          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">{t("footer.navigation")}</h4>
            <div className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-sm text-background-50/60 hover:text-primary-400 transition-colors underline cursor-pointer"
                >
                  {t(footerNavLabels[link.href] || link.label)}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">{t("footer.contact")}</h4>
            <div className="flex flex-col gap-2">
              <a
                href="tel:+41211234567"
                className="text-sm text-background-50/70 hover:text-primary-400 transition-colors"
              >
                +41 26 919 53 60
              </a>
              <a
                href="mailto:service@clefsdelys.ch"
                className="text-sm text-background-50/70 hover:text-primary-400 transition-colors"
              >
                service@clefsdelys.ch
              </a>
            </div>
            <h4 className="text-sm font-semibold text-background-50 mt-6 mb-2">{t("footer.address")}</h4>
            <p className="text-sm text-background-50/50 leading-relaxed">
              Rue Alexandre Cailler 6<br />
              1636 Broc<br />
              Switzerland
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10 px-6 md:px-10 py-4 md:py-5">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">

          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} {t("brand")}. {t("footer.rights")}
          </p>
          <div className="flex items-center gap-4">
            <Link
              to="/privacy"
              className="text-xs text-background-50/50 hover:text-primary-400 transition-colors underline"
            >
              {t("footer.privacy")}
            </Link>
            <Link
              to="/legal-notice"
              className="text-xs text-background-50/50 hover:text-primary-400 transition-colors underline"
            >
              {t("footer.legal")}
            </Link>
            <Link
              to="/terms"
              className="text-xs text-background-50/50 hover:text-primary-400 transition-colors underline"
            >
              {t("footer.terms")}
            </Link>

          </div>
        </div>
      </div>
    </footer>
  );
}